import { css } from '@emotion/react'

const billingPlanLimitedAlert = theme => css`
  min-height: ${theme.spacing[16]};
  background: ${theme.color.primary.negativeAlt};
  button {
    font-weight: ${theme.fontWeight.semibold};
  }
`

const billingPlanLimitedOverdueAlert = css`
  background: #d60000;
`

const learnMoreLink = theme => css`
  &&& {
    color: ${theme.color.primary.info};
    text-decoration: underline;
  }
`

const migrationContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  flex-wrap: wrap;
`

const migrationText = css`
  flex: 1;
  min-width: 0;
`

export const styles = {
  billingPlanLimitedAlert,
  billingPlanLimitedOverdueAlert,
  learnMoreLink,
  migrationContent,
  migrationText,
}
